import React, { useState } from "react"
import CustomAccordion from "../../components/custom-accordion/custom-accordion.component"
import parse from "html-react-parser"

import * as S from "./questions.styles"

const Questions = ({ description, questionTitle, questions }) => {
  const [index, setIndex] = useState(0)
  const [expanded, setExpanded] = useState(false)

  const handleChange = panel => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false)
  }

  const handleClick = value => {
    setIndex(value)
  }
  return (
    <S.Section>
      <S.Wrapper>
        <S.Description>{parse(description)}</S.Description>
        <S.FaqsContainer>
          <S.QuestionsTitle>{questionTitle}</S.QuestionsTitle>
          {questions?.map(({ title, description }, index) => (
            <CustomAccordion
              key={`${title}-${index}`}
              question={title}
              answer={description}
              handleChange={handleChange}
              expanded={expanded}
            />
          ))}
        </S.FaqsContainer>
      </S.Wrapper>
    </S.Section>
  )
}

export default Questions
